import UsuariosService from "@/services/accounts/UsuariosService";



const permisos = (context, params) => {
  return UsuariosService.profile()
    .then(res => {
      context.commit('PERMISOS', res.data);
    });
};

export default {
  permisos,
};